<template>
  <div
    class="footer-modular"
    :style="
      this.$route.path == '/shoppingcart' && equipmentType == 1
        ? 'margin-bottom: 80px;'
        : ''
    "
  >
    <div class="footer-center-modular">
      <el-row :gutter="10">
        <el-col :xs="8" :sm="8" :md="5" :lg="5"  v-for="(items, indexs) in bottom_data"
                :key="indexs">
          <div class="footer-tar-item-modualr">
            <div class="footer-top-title">
              {{ currLanguage == 3 ? items.eng_name : items.name }}
            </div>
            <div class="footer-tar-msg">
              <div
                class="footer-msg-item"
                v-for="(item, index) in bottom_data[indexs].child"
                :key="index"
                @click="
                  toNext(
                    currLanguage == 3 ? bottom_data[indexs].eng_name : bottom_data[indexs].name,
                    currLanguage == 3 ? item.eng_name : item.name,
                    currLanguage == 3 ?item.eng_detail:item.detail,
                    item.id
                  )
                "
              >
                {{ currLanguage == 3 ? item.eng_name : item.name }}
              </div>
            </div>
          </div>
        </el-col>
        
        <el-col :xs="24" :sm="24" :md="9" :lg="9">
          <div class="footer-tar-item-modualr footer-tar-subscribe-modular">
            <div class="footer-top-title">
              {{ pageTextArr[1] }}
            </div>
            <div>
              <el-input
                :placeholder="pageTextArr[0]"
                type="email"
                v-model="subscribeMainInput"
              >
                <el-button slot="append" @click="subscribeByemail()">{{
                  pageTextArr[2]
                }}</el-button>
              </el-input>
            </div>
            <div class="footer-share-modualr">
              <div class="footer-share-title">
                {{ pageTextArr[3] }}
              </div>
              <div
                class="share-img-method"
                style="display: flex; justify-content: flex-end"
              >
                <div v-for="(item, index) in shareImg" :key="index">
                  <a :href="item.toUrl" tagert="_blank">
                    <img
                      class="share-icon"
                      :src="item.flag ? item.url2 : item.url1"
                      @mousemove="setImgFlag(true,index)"
                      @mouseout="setImgFlag(false,index)"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="copyright-info-modular">
      2022 {{ copyright }} <a style="cursor:pointer" @click="jumpurl()" class="copyright-info-modular-font" >鲁ICP备2023020886号</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "footer",
  data() {
    return {
      copyright:
        " © iChuk.com iChuk 江苏爱察信息技术有限公司 增值电信业务经营许可证：苏B2-20201595 保留所有权利。备案号：",
      title1: {
        title: "相关政策",
        msg: [
          {
            key: "",
            value: "运输正常",
          },
          {
            key: "",
            value: "退款政策",
          },
          {
            key: "",
            value: "运费政策",
          },
          {
            key: "",
            value: "服务条款",
          },
        ],
      },
      title2: {
        title: "客户服务",
        msg: [
          {
            key: "",
            value: "订单跟踪",
          },
          {
            key: "",
            value: "地点和工作时间",
          },
          {
            key: "",
            value: "隐私与安全",
          },
          {
            key: "",
            value: "付款方式",
          },
        ],
      },
      title3: {
        title: "了解我们",
        msg: [
          {
            key: "",
            value: "公司介绍",
          },
          {
            key: "",
            value: "联系方式",
          },
        ],
      },
      bottom_data:[

      ],
      subscribeMainInput: "", //订阅的邮箱
      shareImg: [
        {
          flag: false,
          url1: require("../../assets/public/footer-icon-1-1.png"),
          url2: require("../../assets/public/footer-icon-1-2.png"),
          toUrl: "https://www.instagram.com/ginkgoem_onlineshop/",
        },
        // {
        //   flag: false,
        //   url1: require('../../assets/public/footer-icon-2-1.png'),
        //   url2: require('../../assets/public/footer-icon-2-2.png'),
        //   toUrl:""
        // },
        {
          flag: false,
          url1: require("../../assets/public/footer-icon-3-1.png"),
          url2: require("../../assets/public/footer-icon-3-2.png"),
          toUrl: "https://www.youtube.com/@ginkgoem2877",
        },
        {
          flag: false,
          url1: require("../../assets/public/footer-icon-4-1.png"),
          url2: require("../../assets/public/footer-icon-4-2.png"),
          toUrl: "https://twitter.com/frank31167187",
        },
        // {
        //   flag: false,
        //   url1: require('../../assets/public/footer-icon-5-1.png'),
        //   url2: require('../../assets/public/footer-icon-5-2.png'),
        //   toUrl:""
        // },
        // {
        //   flag: false,
        //   url1: require('../../assets/public/footer-icon-6-1.png'),
        //   url2: require('../../assets/public/footer-icon-6-2.png'),
        //   toUrl:""
        // }
      ],
      // 手机端，PC端
      equipmentType: 0,
      pageText: {
        emailplaceholder: "请输入邮箱",
        subscribetitleText: "订阅我们的时事通讯",
        subscribeText: "订阅",
        // shareToText: '分享至'
        shareToText: "关注我们",
      },
      pageTextArr: [
        '请输入邮箱',
        '订阅我们的时事通讯',
        '订阅',
        '关注我们',
        '订阅成功',
        '订阅失败'
      ]
    };
  },
  methods: {
    /**
     * 获取页面底部
     */
    getBottomList() {
      let that = this;
      // if (
      //   localStorage.getItem("bottomTitle1") != null &&
      //   localStorage.getItem("bottomTitle2") != null &&
      //   localStorage.getItem("bottomTitle3") != null
      // ) {
      //   that.title1 = JSON.parse(localStorage.getItem("bottomTitle1"));
      //   that.title2 = JSON.parse(localStorage.getItem("bottomTitle2"));
      //   that.title3 = JSON.parse(localStorage.getItem("bottomTitle3"));
      //   return;
      // } else {
        this.$http.getBottomList(
          null,
          (res) => {
            if (res.ret == 1) {
              that.bottom_data=res.data;
              
              if(that.bottom_data.length>0 && this.currLanguage!=3 && this.currLanguage!=1){
               // api数据翻译
              that.bottomListArrdata(res.data, "name");
            }
            
          } else {
              // this.$message.error(res.msg);
            }
          },
          (res) => {
            // this.$message.error(res.msg);
          }
        );
      // }
    },

    /**
     * 底部页脚数据处理
     * @param {*} data
     * @param {*} title
     */
     bottomListArrdata(data, title) {
      let that = this;
      let newTextArr = [];
      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.bottom_languageTranslateByArr(newTextArr, "name", 1);

      let childrenTextArr = [];
      // debugger
      that.bottom_data.forEach((v, i) => {
        // console.log('v', v.level1.children);
        if (v.child != undefined && v.child.length > 0) {
          v.child.forEach((v2, i2) => {
            childrenTextArr.push(i + "@"+i2+"@" + v2[title]);
          });
        }
      });
      // console.log('childrenTextArr==i' , childrenTextArr);

      that.bottom_languageTranslateByArr(childrenTextArr, "name", 2);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
     bottom_languageTranslateByArr(arr, title, lev) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          console.log("languageTranslateByArr",res);
          // 翻译api类型
          that.bottom_processingResultsByArr(res.data, title, lev);
        },
        (res) => {}
      );
    },

    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
     bottom_processingResultsByArr(data, title, lev) {
      let that = this;
      switch (lev) {
        // 分类一级数据
        case 1:
          data.forEach((v, i) => {
            that.bottom_data[i].name = v.translation;
          });
          break;
        //分类二级数据
        case 2:
          let childIndex = 0;
          let lastIndex = 0;
          data.forEach((v, i) => {
            let index = v.query.split("@")[0];
            let childIndex=v.query.split("@")[1]
            that.bottom_data[index].child[childIndex].name =
              v.translation.split("@")[2];
          });
          break;

        default:
          break;
      }
    },

    /**
     * 页面跳转
     * @param {*} path
     */
    toNext(titleName, itemName, detail,id) {
      console.log("detail", titleName, itemName);
      this.$router.replace(
        {
          path: "/newsPolicy",
          query: {
            titleName: titleName,
            itemName: itemName,
            id:id
          },
        },
        () => {}
      );
      this.$parent.$parent.reload();
      // localStorage.setItem("detail", detail);
    },

    /**
     * 订阅
     */
    subscribeByemail() {
      let that = this;
      if (that.subscribeMainInput == "") {
        this.$message.warning(
          that.currLanguage == 3
            ? "Please fill in the subscription mailbox"
            : this.pageTextArr[0]
        );
      } else {
        // 订阅
        that.subscribe();
      }
    },

    /**
     * 订阅
     */
    subscribe() {
      let that = this;
      let data = {
        email: that.subscribeMainInput,
      };
      this.$http.subscribe(
        data,
        (res) => {
          if (res.ret == 1) {
            that.subscribeMainInput = "";
            this.$message.success(this.pageTextArr[4]);
          } else {
            this.$message.success(this.pageTextArrpageTextArr[4]);
          }
        },
        (res) => {
          this.$message.success(this.pageTextArr[4]);
        }
      );
    },

    getEquipmentType() {
      let that = this;
      that.equipmentType = localStorage.getItem("equipmentType");
    },

    jumpurl(){
      let path=window.location.protocol+'//'+"beian.miit.gov.cn/"
      window.location.href=path
    },
    /**
     * 语言翻译-单个词语
     */
    pageTranslate(text) {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + ":" + that.pageText[key] + "&";
      }
      console.log('transformText',transformText);
      that.languageTranslate(transformText);
    },

    /**
     * 语言翻译 - 单个词语
     * @param {*} text
     */
    languageTranslate(text) {
      let that = this;
      
      this.$parent.translate(
        text,
        (res) => {
          // 处理页面 死数据 -翻译
          console.log("text",res.data);
          that.processingResults(res.data);
        },
        (res) => {}
      );
    },

    /**
     *  语言翻译 - 单个词语-
     * @param {*} text
     */
    languageTranslateByText(text, type) {
      let that = this;
      // console.log("text",text);
      this.$parent.translate(
        text,
        (res) => {
          if (type == 1) {
            console.log("text",text);
            that.title1.name = res.data;
          } else if (type == 2) {
            that.title2.name = res.data;
          } else if (type == 3) {
            that.title3.name = res.data;
          } else {
            that.copyright = res.data;
          }
        },
        (res) => {}
      );
    },

    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");
      // console.log('textArr',textArr);
      textArr.forEach((v, i) => {
        if (v != "") {
          for (const key in that.pageText) {
            if (v.split(":")[0] == key) {
              that.pageText[key] = v.split(":")[1];
            }
          }
        }
      });
      console.log("that.pageText",that.pageText);
    },

   
    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, title) {
      let that = this;
      let newTextArr = [];
      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.languageTranslateByArr(newTextArr, title);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, title);
        },
        (res) => {}
      );
    },

    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title) {
      let that = this;
      // if(data){
      //   data.forEach((v, i) => {
      //     console.log(data,111)
      //   console.log(i,222)
      //   console.log(title,333)
      //   that.searchTar[i][title] = v.translation;
      // });
      // }
      
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr){
      let that = this
      let newpagetextArr = []
      that.translateByArr(arr,res=>{
        console.log("res",res);
        res.data.forEach((item,index)=>{
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
    },

    /**
     * 鼠标移入移出更改图片
     * @param {*} flag 
     * @param {*} index 
     */
    setImgFlag(flag,index){
      let that = this;
      let newData = that.shareImg[index];
      newData.flag = flag;
      this.$set( that.shareImg,newData,index);
    }
  },
  mounted() {
    let that = this;
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 获取页面底部
    that.getBottomList();
    this.getEquipmentType();
    // 翻译
    // that.pageTranslate();
    that.languageTranslateByText(that.copyright, 4);
    that.languageTranslateByArrs(that.pageTextArr);

  },
};
</script>

<style lang="scss">
.footer-modular {
  width: 100%;
  padding-top: 62px;
  padding-bottom: 34px;
  background: #000000;
  // position: fixed;
  // bottom: 0;
  // left: 0;

  .footer-center-modular {
    // display: flex;
    width: 1200px;
    // width: 1920px;
    margin: auto;
    .el-row {
      // padding: 0 60px;
      // padding-right: 30px;
    }

    .footer-tar-item-modualr {
      // width: 20%;

      .footer-top-title {
        // cursor: pointer;
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 27px;
      }

      .footer-tar-msg {
        .footer-msg-item {
          cursor: pointer;
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          margin: 10px 0px;
        }
      }
    }

    .footer-tar-subscribe-modular {
      text-align: right;

      .el-input-group__append {
        background: #ec0000;
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        border: 0;
        padding: 0;
        width: 113px;
        text-align: center;
      }

      .footer-share-modualr {
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
        margin-top: 44px;

        .share-icon {
          widows: 35px;
          height: 35px;
          margin-left: 20px;
          margin-top: 10px;
        }
      }
    }
  }

  .copyright-info-modular {
    width: 1200px;
    margin: auto;
    margin-top: 60px;
    padding-top: 32px;
    border-top: 1px solid #cacaca;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }

   .copyright-info-modular-font {
    color: #ffffff;
  }
}

@media screen and (max-width: 500px) {
  .footer-modular {
    .footer-center-modular {
      width: 95%;

      .footer-tar-item-modualr {
        text-align: center;
      }

      .footer-tar-subscribe-modular {
        margin-top: 30px;
        text-align: left;
      }
    }

    .copyright-info-modular {
      width: 90%;
      line-height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue